import * as T from "../Controls.style";
import * as S from "./SelectControl.style";
import { get } from "lodash";
import { Inputs } from "@/components/atoms/Inputs";
import { Control, Controller } from "react-hook-form";

interface SelectControlProps {
  ref?: React.LegacyRef<HTMLSelectElement>;
  name: string;
  data?: any;
  label?: string;
  value?: string;
  options: any;
  control: Control<any>;
  valueKey?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (value: string) => void;
  displayKey?: string;
  placeholder?: string;
}

export const SelectControl = ({
  name,
  label,
  value,
  control,
  options,
  required,
  disabled,
  valueKey,
  onChange,
  displayKey,
  placeholder,
}: SelectControlProps) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, formState }) => (
        <>
          <Inputs label={label} required={required ? required : false}>
            <S.SelectBox>
              <S.Select
                name={name}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  field.onChange(selectedValue);
                  if (onChange) {
                    onChange(selectedValue);
                  }
                }}
                disabled={disabled}
                value={value || field.value || ""}
                hasValue={!!(value || field.value)}
              >
                {placeholder && (
                  <S.Placeholder value="" disabled={false}>
                    {placeholder}
                  </S.Placeholder>
                )}
                {options &&
                  options.map((item: any) => {
                    const itemValue = valueKey ? item[valueKey] : item.value;
                    return (
                      <option
                        key={`${item.label}_${itemValue}`}
                        value={itemValue}
                      >
                        {displayKey ? item[displayKey] : item.label}
                      </option>
                    );
                  })}
              </S.Select>
            </S.SelectBox>
          </Inputs>
          {typeof get(formState.errors, name)?.message === "string" && (
            <T.Controls>
              <span>{get(formState.errors, name)?.message as string}</span>
            </T.Controls>
          )}
        </>
      )}
    />
  );
};
